export enum TimelineDateStyle {
	Absolute = "absolute",
	Relative = "relative",
}
